import React, {ReactElement, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import {IElementImageGallery} from '../../../../../incase-domain/elements/imageGallery';
import {swapArrayIndices} from '../../../../../utils/utils';
import Button from '../../../../../incase-domain/components/button/Button';
import ImageGalleryItemContextMenu from '../../../../../ui/components/contextMenu/ImageGalleryItemContextMenu';
import Label from '../../../../../incase-domain/components/label/Label';

interface ElementImageGalleryEditComponentProps {
    element: IElementImageGallery;
    highlightedElementChangeHandler: {single: (filed: keyof IElementImageGallery, value: unknown) => void};
}
function ElementImageGalleryEditComponent(props: ElementImageGalleryEditComponentProps): ReactElement {
    const {element, highlightedElementChangeHandler} = props;
    const {images} = element;
    const {t} = useTranslation();

    const [openPreview, setOpenPreview] = useState(false);
    const [previewImageSrc, setPreviewImageSrc] = useState('');

    function handleMoveUp(imageId: string): void {
        const index = images.findIndex((image) => image.id === imageId);
        if (index === 0) return;

        const newOrderImagesArray = swapArrayIndices(images, index - 1, index);

        highlightedElementChangeHandler.single('images', newOrderImagesArray);
    }

    function handleMoveDown(imageId: string): void {
        const index = images.findIndex((image) => image.id === imageId);
        if (index === images.length - 1) return;

        const newOrderImagesArray = swapArrayIndices(images, index, index + 1);

        highlightedElementChangeHandler.single('images', newOrderImagesArray);
    }

    function handleDelete(imageId: string): void {
        const newImagesAray = images.filter((image) => image.id !== imageId);
        highlightedElementChangeHandler.single('images', newImagesAray);
    }

    return (
        <>
            {images.length > 0 ? (
                <div className="c-elementList">
                    {images.map((element) => (
                        <ImageGalleryItemContextMenu
                            key={element.id}
                            menuId={element.id}
                            element={element}
                            onMoveUp={() => handleMoveUp(element.id)}
                            onMoveDown={() => handleMoveDown(element.id)}
                            onDelete={() => handleDelete(element.id)}
                        >
                            <Button
                                className="c-elementList__elementTile"
                                variant="ghost"
                                size="sm"
                                fullWidth
                                leading="solar:gallery-bold-duotone"
                                onClick={() => {
                                    setPreviewImageSrc(element.imageSrc);
                                    setOpenPreview(true);
                                }}
                            >
                                {`${t('designSidepanel.image')} ${element.id}`}
                            </Button>
                        </ImageGalleryItemContextMenu>
                    ))}
                </div>
            ) : (
                <Label className="u-flex u-h-center">{t('designSidepanel.noImagesPresent')}</Label>
            )}
            <Lightbox
                open={openPreview}
                close={() => {
                    setOpenPreview(false);
                }}
                slides={[{src: previewImageSrc}]}
                animation={{zoom: 500}}
                zoom={{
                    scrollToZoom: true,
                    maxZoomPixelRatio: 5,
                }}
            />
        </>
    );
}

export default ElementImageGalleryEditComponent;
